<template>
    <div class="wave">
      <h1 class="text-center wave__header">
        A Wave of Disruptive Innovation in the Global VNO Market
      </h1>
      <video
        playsinline
        autoplay
        muted
        loop
        class="mx-auto d-block wave__video w-100"
      >
        <source
          src="https://res.cloudinary.com/dmhhkhgny/video/upload/v1745924823/website/gp6e0vlium4cu6n5l8p2.mp4"
          type="video/mp4"
        />
      </video>
    </div>
  </template>
  
  <script setup>
  
</script>
  
<style scoped>
  .wave {
  position: relative;
  width: 100%;
  height: 100vh;
}

.wave__header {
  position: absolute;
  top: 25%;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  font-size: 4rem;
  font-weight: 700;
  color: white;
  text-align: center;
  line-height: 1.5;
  z-index: 1;
}

@media (max-width: 768px) {
  .wave__header {
    font-size: 3rem;
    top: 30%;
    width: 90%;
  }
}

@media (max-width: 480px) {
  .wave__header {
    font-size: 2rem;
    top: 35%;
    width: 95%;
  }
}

.wave__video {
  position: absolute;
  top: -61px;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}
</style>
  